import {useQuery} from '@tanstack/react-query';
import {AxiosError, AxiosResponse} from 'axios';
import {AxiosErrorToast} from '../general/ReusableFunctions';
import {IApiDataResponse} from '../../dto/API.dto';
import axiosInstance from '../../axiosConfig';
import {IPlayerDeviceDetail} from '../../dto/PlayerDeviceDetail.dto';

export interface IStationLoginInfo {
  name: string;
  password: string;
}

interface IApiDataResponseWithStation<T> extends IApiDataResponse<T> {
  station: IStationLoginInfo;
}

export const getStationDevicesApiPath = (
  company_id: number,
  station_id: number,
) => `/v1/company/${company_id}/station/${station_id}/devices`;

export type IPlayerDeviceDetailResponse = IPlayerDeviceDetail & {
  name: string;
};

const getStationDevices = (
  company_id: number,
  station_id: number,
): Promise<[IPlayerDeviceDetailResponse[], IStationLoginInfo]> => {
  return axiosInstance
    .get(getStationDevicesApiPath(company_id, station_id))
    .then(
      (
        response: AxiosResponse<
          IApiDataResponseWithStation<IPlayerDeviceDetailResponse[]>
        >,
      ) => {
        const devices = response.data.data;
        const station = response.data.station;
        return [devices, station] as [
          IPlayerDeviceDetailResponse[],
          IStationLoginInfo,
        ];
      },
    )
    .catch((error: AxiosError) => {
      AxiosErrorToast(error, 'Error in listing station devices');
      throw error;
    });
};
export const useRqListStationDevices = (
  company_id: number,
  station_id: number,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: [getStationDevicesApiPath(company_id, station_id)],
    queryFn: () => getStationDevices(company_id, station_id),
    refetchOnWindowFocus: false,
    retry: false,
    enabled: enabled,
  });
};
